export const propertiesCardStyles = {
  listItem: {
    pl: 4,
    overflowWrap: 'break-word',
  },
  actions: {
    right: '20px',
  },
  isEdited: {
    fontWeight: 'fontWeightBold',
  },
};
